// Page templates for SitePagesManager — pre-fills content + SEO schema.

export const PAGE_TEMPLATES = {
  blank: {
    label: "Blank page",
    description: "Start from scratch.",
    apply: (form) => form,
  },
  faq: {
    label: "FAQ (with Google-ready schema)",
    description: "Pre-fills common mold / water restoration FAQs + JSON-LD FAQPage schema.",
    apply: (form) => ({
      ...form,
      title: form.title || "Frequently Asked Questions",
      meta_description:
        form.meta_description ||
        "Common questions about mold remediation, water damage restoration, and flood response — answered by ATC's certified team.",
      hero_eyebrow: form.hero_eyebrow || "Got questions?",
      hero_title: form.hero_title || "We've got answers.",
      hero_subtitle:
        form.hero_subtitle ||
        "Everything homeowners and property managers ask us — from \"is my mold dangerous?\" to \"will insurance cover this?\"",
      content_html: FAQ_CONTENT_HTML,
      seo_schema_json: JSON.stringify(FAQ_SCHEMA, null, 2),
    }),
  },
};

const FAQ_ENTRIES = [
  {
    q: "Is mold in my home dangerous?",
    a: "Some mold species (like Stachybotrys chartarum — \"black mold\") release mycotoxins that can cause respiratory irritation, headaches, and worsen asthma. Even ordinary mold can trigger allergies. If you see visible mold larger than a small patch, or you smell a persistent musty odor, schedule an assessment.",
  },
  {
    q: "How fast do you respond to water damage emergencies?",
    a: "We dispatch 24/7 and are typically on-site within 60 minutes of your call. Faster response means less secondary damage — water that sits longer than 24–48 hours dramatically increases mold risk.",
  },
  {
    q: "Will my homeowner's insurance cover this?",
    a: "Most sudden water-damage events (burst pipes, appliance failures, storm intrusion) are covered. Gradual leaks and pre-existing mold often aren't. We provide full documentation — moisture readings, photos, and IICRC-aligned scope of work — to support your claim.",
  },
  {
    q: "How long does mold remediation take?",
    a: "A typical residential mold job runs 2–5 days: containment & setup (day 1), removal & cleaning (days 2–3), drying & post-test (days 4–5). Larger commercial jobs take longer.",
  },
  {
    q: "Can I stay in my home during restoration?",
    a: "Usually yes. We seal off the affected area with negative-air containment so the rest of your home stays clean. For Category 3 (sewage / black water) losses, we'll discuss temporary relocation.",
  },
  {
    q: "Do you handle the rebuild after drying?",
    a: "Yes — we handle drywall, paint, flooring, and cabinetry repair so you only have one point of contact through the entire claim.",
  },
];

const FAQ_CONTENT_HTML = `<h2>Frequently Asked Questions</h2>
<p>Below are the questions we get most often. If yours isn't covered, call us 24/7 — we're happy to walk you through it.</p>
${FAQ_ENTRIES.map((e) => `<h3>${e.q}</h3><p>${e.a}</p>`).join("\n")}
<h2>Still have questions?</h2>
<p>Call <strong>(555) 010-2024</strong> or use the contact form on our home page. Most quotes come back within 1 business day.</p>`;

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_ENTRIES.map((e) => ({
    "@type": "Question",
    name: e.q,
    acceptedAnswer: { "@type": "Answer", text: e.a },
  })),
};
